module.exports = __webpack_public_path__ + "static/media/berimbaula.abc4b33b.png";